<template>
  <home-layout>
    <div class="my-16 md:my-24">
      <h1 class="max-w-2xl mx-auto mb-8 text-xl font-bold leading-tight text-center md:text-2xl lg:text-3xl">
        Iffent on platvorm, mis viib kokku tellija, projektijuhi ja vajaliku pädevusega projekteerijad
      </h1>

      <div class="max-w-4xl mx-auto mt-12 md:mt-20 lg:mt-32">
        <new-project-search :building-types="buildingTypes" />
      </div>
    </div>

    <div class="my-16 ">
      <div class="flex flex-wrap justify-center my-8 md:my-16 lg:my-24">
        <router-link to="/auth?selected=1" class="m-1 text-white bg-blue-500 btn">
          Olen tellija
        </router-link>

        <router-link to="/auth?selected=2" class="m-1 text-white bg-blue-500 btn">
          Olen projektijuht
        </router-link>

        <router-link to="/auth?selected=3" class="m-1 text-white bg-blue-500 btn">
          Olen projekteerija
        </router-link>
      </div>
    </div>

    <div class="flex flex-wrap pb-10 sm:pb-6 lg:pb-8">
      <div class="flex flex-wrap w-full md:w-1/2 lg:w-1/2 py-3 px-6">
        <div class="flex items-center">
          <i style="font-size: 2rem" class="font-bold text-blue-500 px-3 pi pi-euro"></i>
          <h3 class="max-w-lg font-semibold md:text-lg lg:text-xl">
            Pakkumiste summa: <span class="max-w-xl text-xl font-bold md:text-xl lg:text-2xl"> {{ statistics.offer.sum }} € </span>
          </h3>
        </div>
        <divider/>
        <div class="flex items-center">
          <i style="font-size: 2rem" class="font-bold text-blue-500 px-3 pi pi-user"></i>
          <h3 class="max-w-lg font-semibold md:text-lg lg:text-xl">
            Spetsialiste: <span class="max-w-xl text-xl font-bold md:text-xl lg:text-2xl"> {{ statistics.specialistCount }} </span>
          </h3>
        </div>
      </div>
      <div class="w-full md:w-1/2 lg:w-1/2 py-3 px-6 text-center">
        <div class="flex items-center">
          <i style="font-size: 2rem" class="font-bold text-blue-500 px-3 pi pi-building"></i>
          <h3 class="max-w-lg font-semibold md:text-lg lg:text-xl">
            Projektide arv: <span class="max-w-xl text-xl font-bold md:text-xl lg:text-2xl"> {{ statistics.projectCount }} </span>
          </h3>
        </div>
        <divider/>
        <div class="flex items-center">
          <i style="font-size: 2rem" class="font-bold text-blue-500 px-3 pi pi-percentage"></i>
          <h3 class="max-w-lg font-semibold md:text-lg lg:text-xl">
            Pakkumise saanute osakaal: <span class="max-w-xl text-xl font-bold md:text-xl lg:text-2xl"> {{ chartPercentage }} % </span>
          </h3>
        </div>
      </div>
    </div>
  </home-layout>
</template>

<script>
import HomeLayout from './../Layouts/HomeLayout'
import {getBuildingTypes, getStatistics} from "@/store/public.api";

export default {
  components: {
    HomeLayout
  },
  metaInfo: {
    title: 'Iffent',
    titleTemplate: null,
    meta: [
      { name: 'description', content: 'Iffent on platvorm, mis viib kokku tellija, projektijuhi ja vajaliku pädevusega projekteerijad' },
      { name: 'keywords', content: 'Iffent, platvorm, tellija, projektijuht, projekteerija, projekteerimine, meeskond, hoone projekt, hoone, projekt' },
      { property: 'og:title', content: 'Iffent' },
      { property: 'robots', content: 'index, follow' },
    ]
  },
  computed: {
    chartPercentage() {
      return ((this.statistics?.offer?.specialistOfferCount / this.statistics?.specialistCount) * 100).toFixed(2) ;
    }
  },
  data() {
    return{
      buildingTypes: [],
      statistics: {
        specialistCount: 0,
        projectCount: 0,
        offer: {
          specialistOfferCount: 0,
          sum: 0,
        }
      },
    }
  },
  async mounted() {
    getBuildingTypes().then((resp) => {
      this.buildingTypes = resp.data.buildingTypes;
    });
    getStatistics().then((resp) => {
      this.statistics = resp.data;
    })
  }
}
</script>
